<template>
  <div class="content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="content__box">
          <!---- restricted --->
          <div class="content__box__header">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <div class="tabList d-flex mb-1">
                <ul class="top__filter__ul">
                  <li
                    :class="[mode == 'operators' ? 'active' : '']"
                    @click="changeTab('operators')"
                  >
                    Operators/Users
                  </li>
                  <li
                    :class="[mode == 'department' ? 'active' : '']"
                    @click="changeTab('department')"
                  >
                    Departments
                  </li>
                  <li
                    :class="[mode == 'roles' ? 'active' : '']"
                    @click="changeTab('roles')"
                  >
                    Roles
                  </li>
                </ul>
              </div>
              <div class="tabList d-flex mb-1">
                <div class="ml-5">
                  <input
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    class="input__field"
                    style="width:150% !important"
                    v-model="search"
                    @keyup="searchData"
                  />
                </div>
              </div>
              <div class="tabList d-flex mb-1 ml-5">
                <div class="ml-5 top__filter__ul">
                  <p class="text-white txt--ss opacity--50 mb-1">Status</p>
                </div>
                <div class="ml-2">
                 <v-select
                            class="style-chooser monthly-filter-select selectTransparent"
                            label="name"
                            :searchable="false"
                            v-model="selected_status"
                            transition="none"
                            :options="status_list"
                            :clearable="false"
                            :reduce="(name) => name.value"
                            @input="changeSelectedStatus()"
                            placeholder="Select Status"
                          >
                  </v-select>
                </div>
              </div>

              <div class="tabList d-flex mb-1 ml-1" v-if="search!='' || selected_status!=-1">
                <div class="ml-5 top__filter__ul">
                  <p class="text-white txt--ss opacity--50 mb-1 cursor-pointer" @click="resetFilter">Clear Filters</p>
                </div>
              </div>

              <div
                class="d-flex align-items-center order-3 ml-auto"
                v-if="mode === 'operators'"
              >
                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openModal('add-user-modal','')"
                >
                  + Add Operator/User
                </p>

                <p class="txt--off-white txt--ss mb-1 cursor-pointer d-none" @click="openModal('csv-upload-modal','operator')">
                  Upload CSV
                </p>
              </div>
              <div
                class="d-flex align-items-center order-3 ml-auto"
                v-if="mode === 'department'"
              >
                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openModal('add-department-modal','')"
                >
                  + Add Departments
                </p>

                <p class="txt--off-white txt--ss mb-1 cursor-pointer d-none" @click="openModal('csv-upload-modal','department')">
                  Upload CSV
                </p>
              </div>
              <div
                class="d-flex align-items-center order-3 ml-auto"
                v-if="mode === 'roles'"
              >
                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openModal('add-roles-modal','')"
                >
                  + Add Roles
                </p>

                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer d-none"
                  @click="openModal('csv-upload-modal','role')"
                >
                  Upload CSV
                </p>
              </div>
            </div>
          </div>
          <div class="content__divider"></div>
          <div
            class="content__box__body content__box__body__audit__table"
            v-if="mode === 'operators'"
          >
            <div class="table-responsive">
              <input type="hidden" id="permitId" />
              <table class="table table__audit table-borderless">
                <thead>
                  <tr>
                    <th class="txt--primary">
                      First Name 
                       <span 
                          class="pl-1 cursor-pointer" 
                          v-if="order_by == 'DESC'" 
                          @click="setOrderBy(field_name,'ASC','operator')"
                        >
                          <i class="fas fa-angle-up"></i>
                        </span>
                        <span 
                          class="pl-1 cursor-pointer" 
                          v-if="order_by == 'ASC'" 
                          @click="setOrderBy(field_name,'DESC','operator')"
                        >
                          <i class="fas fa-angle-down"></i>
                        </span>
                    </th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Department</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="cursor: default" v-for="(operator,index) in operatorUserLists" :key="index">
                    <td class="cursor-pointer txt--primary" @click="editOperator(operator)">
                      {{ operator.first_name }}
                    </td>
                    <td>{{ operator.last_name!=''?operator.last_name:'-' }}</td>
                    <td>
                      <p title="click to copy" class="cursor-pointer">
                        {{ operator.email }}
                      </p>
                    </td>
                    <td>
                      <p title="click to copy" class="cursor-pointer">                   
                        <span class="cursor-pointer"
                          :class="{
                          'txt--green': operator.role.status === 1,
                          'txt--red': operator.role.status === 0 || operator.role.status === -1,
                        }"
                        >
                         {{ operator.role !=''?  operator.role.name:'-'}}
                         {{ operator.role !=''? (operator.role.status === -1 ? ' (DELETED)':''):''}}
                        </span>
                      </p>
                    </td>
                    <td>
                      <span> 
                        
                        <span class="cursor-pointer"
                          :class="{
                          'txt--green': operator.department.status === 1,
                          'txt--red': operator.department.status === 0 || operator.department.status === -1,
                        }"
                        >
                        {{ operator.department!=''? operator.department.department_name:'-' }}
                        {{ operator.department !=''? (operator.department.status === -1 ? ' (DELETED)':''):''}}
                        </span>
                      </span>
                    </td>
                    <td>
                      
                    <!--   <span class="txt--green" v-if="operator.status ==1" @click="changeOperatorStatus(0)">Active</span>
                      <span class="txt--red" v-if="operator.status == 0" @click="changeOperatorStatus(1)">Inactive</span> -->

                      <span class="cursor-pointer"
                          :class="{
                          'txt--green': operator.status === 1,
                          'txt--yellow': operator.status === 0,
                          'txt--red': operator.status === 2,
                        }"
                        
                        @click="
                          changeOperatorStatus(operator.id, operator.status)
                        "
                        >
                        {{
                          operator.status == 1
                            ?"Active"
                            : (operator.status == 2?'Inactive':'Pending')
                        }}
                        </span>
                      
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="cursor-pointer" @click="editOperator(operator)"> Edit </span>
                        <span class="cursor-pointer txt--red ml-2" @click="deleteOperator(operator.id)"> Delete </span>
                      </div>
                    </td>
                  </tr>
                  <!-- <tr style="cursor: default">
                    <td class="cursor-pointer txt--primary">
                      suman2
                    </td>
                    <td>pal</td>
                    <td>
                      <p title="click to copy" class="cursor-pointer">
                        suman@klizos.com
                      </p>
                    </td>
                    <td>
                      <p title="click to copy" class="cursor-pointer">
                        developer
                      </p>
                    </td>
                    <td><span>development</span></td>
                    <td><span class='txt--primary'>Pending</span></td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span class="cursor-pointer"> Edit </span>
                      </div>
                    </td>
                  </tr> -->
                </tbody>
              </table>

              <infinite-loading
                @infinite="getOperatorUserLists"
                :distance="10"
                force-use-infinite-wrapper=".content__box__body.content__box__body__audit__table"
                v-if="operatorUserLists.length > 0 && globalPagination.load_more"
                :identifier="operator_infiniteId"
              >
                <div slot="spinner">
                  <div class="d-flex justify-content-center mt-4">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <div slot="no-more"></div>
                <div slot="no-results">No data found</div>
              </infinite-loading>
            </div>
          </div>
          <div
            class="content__box__body content__box__body__audit__table"
            v-if="mode === 'department'"
          >
            <div class="table-responsive">
              <input type="hidden" id="permitId" />
              <table class="table table__audit table-borderless">
                <thead>
                  <tr>
                    <th width="86%" class="txt--primary">
                      Department Name 
                      <span 
                          class="pl-1 cursor-pointer" 
                          v-if="order_by == 'DESC'" 
                          @click="setOrderBy(field_name,'ASC','department')"
                        >
                          <i class="fas fa-angle-up"></i>
                        </span>
                        <span 
                          class="pl-1 cursor-pointer" 
                          v-if="order_by == 'ASC'" 
                          @click="setOrderBy(field_name,'DESC','department')"
                        >
                          <i class="fas fa-angle-down"></i>
                        </span>
                    </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="cursor: default" 
                   v-for="(dept, index) in departmentLists"
                            :key="index"
                  >
                    <td class="cursor-pointer">
                      <span  class="txt--primary"  @click="editDepartment(dept)" v-tooltip="'Edit Department'">
                      {{
                          dept.department_name != ""
                            ? dept.department_name
                            : 'Not Found'
                      }}
                      </span>
                    </td>
                    <td>
                        <span class="cursor-pointer"
                          :class="{
                          'txt--green': dept.status === 1,
                          'txt--red': dept.status === 0,
                        }"
                        
                        @click="
                          changeDepartmentStatus(dept.department_id, dept.status)
                        "
                        >
                        {{
                          dept.status == 1
                            ?"Active"
                            : 'Inactive'
                        }}
                        </span>
                    </td>
                    <td>
                      <div class="d-flex align-items-center" v-tooltip="'Edit Department'">
                        <span class="cursor-pointer" @click="editDepartment(dept)"> Edit </span>
                        <span class="cursor-pointer txt--red ml-2" @click="deleteDepartment(dept.department_id)"> Delete </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <infinite-loading
                @infinite="getDepartmentLists"
                :distance="10"
                force-use-infinite-wrapper=".content__box__body.content__box__body__audit__table"
                v-if="departmentLists.length > 0 && globalPagination.load_more"
                :identifier="department_infiniteId"
              >
                <div slot="spinner">
                  <div class="d-flex justify-content-center mt-4">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <div slot="no-more"></div>
                <div slot="no-results">No data found</div>
              </infinite-loading>
            </div>
          </div>
          <div
            class="content__box__body content__box__body__audit__table"
            v-if="mode === 'roles'"
            
          >
            <div class="table-responsive">
              <input type="hidden" id="permitId" />
              <table class="table table__audit table-borderless">
                <thead>
                  <tr>
                    <th width="86%" class="txt--primary">
                      Roles
                      <span 
                          class="pl-1 cursor-pointer" 
                          v-if="order_by == 'DESC'" 
                          @click="setOrderBy(field_name,'ASC','role')"
                        >
                          <i class="fas fa-angle-up"></i>
                        </span>
                        <span 
                          class="pl-1 cursor-pointer" 
                          v-if="order_by == 'ASC'" 
                          @click="setOrderBy(field_name,'DESC','role')"
                        >
                          <i class="fas fa-angle-down"></i>
                        </span>
                    </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="cursor: default" v-for="(role,index) in roleList" :key="index">
                    <td class="cursor-pointer">
                      <span class="txt--primary" @click="editRole(role)" v-tooltip="'Edit Role'" >{{ role.name }}</span>
                    </td>
                    <!-- <td class="txt--green" v-if="role.status">Active</td>
                    <td class="txt--red" v-else>Deactive</td> -->
                    <td>
                      <span class="cursor-pointer"
                            :class="{
                            'txt--green': role.status === 1,
                            'txt--red': role.status === 0,
                          }"
                          
                          @click="
                            changeRoleStatus(role.id, role.status)
                          "
                          >
                          {{
                            role.status == 1
                              ?"Active"
                              : 'Inactive'
                          }}
                      </span>
                    </td>
                   <!--  <td style="cursor: pointer;" @click="editRole(role)">Edit</td> -->
                    <td>
                      <div class="d-flex align-items-center" v-tooltip="'Edit Role'">
                          <span class="cursor-pointer" @click="editRole(role)"> Edit </span>
                          <span class="cursor-pointer txt--red ml-2" @click="deleteRole(role.id)"> Delete </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <infinite-loading
                @infinite="getRoleLists"
                :distance="10"
                force-use-infinite-wrapper=".content__box__body.content__box__body__audit__table"
                v-if="roleList.length > 0 && globalPagination.load_more"
                :identifier="role_infiniteId"
              >
                <div slot="spinner">
                  <div class="d-flex justify-content-center mt-4">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <div slot="no-more"></div>
                <div slot="no-results">No data found</div>
              </infinite-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <AddUser /> -->
    <!-- <AddDepartment /> -->
    <AddRoles @update_role ="refreshRole"/>

    <EditRole @update_role ="refreshRole"/>
    <EditUser @update_list="refreshOperator"/>
    <!-- <CsvUpload :modalTypeTargeted="modalType" /> -->
    <AddUser @update_list="refreshOperator"/>
    <AddDepartment @update_department="refreshDepartment"/>
    <EditDepartment @update_department="refreshDepartment"/>
    <!-- <AddRoles @update_list="refresh('role')"/> -->
    <CsvUpload @update_list="refreshCurrentList" />
  </div>
</template>
<script>
import commonservices from "../../services/CommonService";
import AddUser from "../../components/modals/AddUser";
import AddDepartment from "../../components/modals/AddDepartment";
import AddRoles from "../../components/modals/AddRoles";
import CsvUpload from "../../components/modals/CsvUpload";
import EditRole from "../../components/modals/EditRole";
import EditUser from "../../components/modals/EditUser";
import EditDepartment from "../../components/modals/EditDepartment";

const service = new commonservices();
export default {
  name: "OperatorUsers",
  components: {
    AddUser,
    AddDepartment,
    AddRoles,
    CsvUpload,
    EditRole,
    EditUser,
    EditDepartment,
  },
  props: ["childModalName","modalTypeTargeted"],
  data() {
    return {
      //sendValidation_component:SendValidation,
      modalType: 'operator',
      department_source: null,
      role_source: null,
      operator_source:null,
      departmentLists: [],
      roleLists: [],
      operatorUserLists: [],
      globalPagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
        to: 0,
        total: 0,
      },
     /*  rolePagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
        to: 0,
        total: 0,
      },
      operatorPagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
        to: 0,
        total: 0,
      },
      departmentPagination: {
        page: 1,
        load_more: true,
        infiniteId: +new Date(),
        to: 0,
        total: 0,
      }, */
      department_infiniteId: +new Date(),
      role_infiniteId: +new Date(),
      operator_infiniteId: +new Date(),
      access_lists: null,
      user_role: "",
      mode: "operators",
      roleList:[],
      order_by:'DESC',
      field_name:'updated_at',//'user_first_name','created_at','updated_at'
      search:'',
      selected_status:-1,
      status_list:[],
      previous_mode:'operators',

    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          // console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        // console.log(binding);
      },
    },
  },
  watch: {},
  created() {

    this.refreshStatus();   
    this.getOperatorUserLists();
  },
  methods: {
    setOrderBy(field,order,tab_name)
    {
      this.order_by     = order;
      this.field_name   = field;
      if(tab_name=='operator')
      {
        this.refreshOperator();
      }
      else if(tab_name=='department')
      {
        this.refreshDepartment();
      }
      else if(tab_name=='role')
      {
        this.refreshRole();
      }
      else
      {
        this.refreshOperator();
        this.refreshDepartment();
        this.refreshRole();

      }
    },
    openModal(modalName,modalType) {
      //alert(modalType);
      // if( modalType!=''){
      //   this.modalType = modalType;
      // }
      //  this.modalType ="role";
      // alert( this.modalType);
      //this.$modal.show(modalName);
      this.$modal.show(modalName, {
        modalTypeTargeted:modalType,
      });
      
      // console.log("01");
    },
   /*  refresh(mode){
      this.globalPagination.page = 1;
      this.globalPagination.load_more = false;
      this.departmentLists = [];
      this.getDepartmentLists();
    }, */
    refreshStatus(){

     
      var objStatusOperator = { "all": -1, "pending": 0, "active": 1, "inactive": 2};
      var objStatusDeptRole = { "all": -1, "active": 1, "inactive": 0};
      
      var objStatus = {};
      if(this.mode=='department' || this.mode=='roles')
      {
          objStatus = objStatusDeptRole;
      }
      else if(this.mode=='operators')
      {
          objStatus = objStatusOperator;
      }
      else
      {
          objStatus = objStatusOperator;
      }
      
      this.status_list = [];

      for (const [key, value] of Object.entries(objStatus)) {
        console.log(key, value);
            this.status_list.push({
                name: key,
                value: value,
            });
      }
  
      if(this.previous_mode =='operators' && this.mode !='operators' && this.selected_status!=-1){
      
          this.selected_status = this.selected_status==0?-1:(this.selected_status==2?0:1);     
      }

      if(this.previous_mode !='operators' && this.mode =='operators' && this.selected_status!=-1){
      
          this.selected_status = this.selected_status==0?2:this.selected_status;     
      }

    },
    resetFilter(){
      this.selected_status=-1;
      this.search = '';
      this.previous_mode = this.mode;
      this.changeTab(this.mode);
    },
    changeTab(status) {
      this.mode = status;
      this.refreshStatus();
      this.refreshCurrentList();   
    
    },
    refreshCurrentList(){
      this.order_by     = 'DESC';
      this.field_name   = 'updated_at'; //updated_at,created_at

      if(this.mode=='department'){
        this.department_infiniteId = +new Date();
        this.refreshDepartment();
        this.getDepartmentLists();
      }
      else if(this.mode=='roles'){
        this.role_infiniteId = +new Date();
        this.refreshRole();
        this.getRoleLists();
      }
      else if(this.mode=='operators'){
        this.operator_infiniteId = +new Date();
        this.refreshOperator();
        this.getOperatorUserLists();
      }
      else{
        this.operator_infiniteId = +new Date();
        this.refreshOperator();
        this.getOperatorUserLists();
      }

      this.previous_mode = this.mode;
    
    },
    changeSelectedStatus(){

     // alert(this.selected_status);
      
        if(this.mode=='department'){
          this.department_infiniteId = +new Date();
          this.refreshDepartment();
          this.getDepartmentLists();
        }
        else if(this.mode=='roles'){
          this.role_infiniteId = +new Date();
          this.refreshRole();
          this.getRoleLists();
        }
        else if(this.mode=='operators'){
          this.operator_infiniteId = +new Date();
          this.refreshOperator();
          this.getOperatorUserLists();
        }
        else{
          this.operator_infiniteId = +new Date();
          this.refreshOperator();
          this.getOperatorUserLists();
        }
    },
    searchData(){
      
       if(this.mode=='department'){
        this.department_infiniteId = +new Date();
        this.refreshDepartment();
        this.getDepartmentLists();
      }
      else if(this.mode=='roles'){
        this.role_infiniteId = +new Date();
        this.refreshRole();
        this.getRoleLists();
      }
      else if(this.mode=='operators'){
        this.operator_infiniteId = +new Date();
        this.refreshOperator();
        this.getOperatorUserLists();
      }
      else{
        this.operator_infiniteId = +new Date();
        this.refreshOperator();
        this.getOperatorUserLists();
      }
    },
    getOperatorUserLists(){
      if (this.operator_source) {
        this.operator_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.operator_source = CancelToken.source();

      this.axios
        .post(window.hostname + "/api/auth/operator/user-list", {  
            page: this.globalPagination.page,
            order_by:     this.order_by,
            field_name:   this.field_name,
            search: this.search,
            status: this.selected_status,
          },
          {
            cancelToken: this.operator_source.token,
          }     
        ).then((res)=>{
          /* if(res.data.status){
            this.operatorUserLists  = res.data.data.operator_list;
            this.operatorPagination = res.data.datapagination;
            this.operator_infiniteId++;
            // console.log(this.operatorUserLists);
          } */

           if (res.data.status && Object.keys(res.data.data).length > 0 ) {

              let operatorUser_Lists = res.data.data.operator_list;
              operatorUser_Lists.map((val) => {
                this.operatorUserLists.push(val);
              });

              this.globalPagination.page = res.data.data.pagination.page;
              
              this.globalPagination.load_more =
                res.data.data.pagination.load_more == 1 ? true : false;
              this.globalPagination.to = res.data.data.pagination.to;
              this.globalPagination.total = res.data.data.pagination.total;
              this.operator_infiniteId++;
          } else {
              this.globalPagination.page = 1;
              this.globalPagination.load_more = false;
              this.globalPagination.total = 0;
              this.globalPagination.to = 0;
              this.operatorUserLists = [];
          }
        });
    },
    refreshOperator(){
      this.globalPagination.page = 1;
      this.globalPagination.load_more = false;
      this.operatorUserLists=[],
      this.getOperatorUserLists();
    },
    editOperator(operator){
      this.$modal.show("edit-user-modal", {
        operator: JSON.parse(JSON.stringify(operator)),
      });      
    },
    deleteOperator(operator_id){
      
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this Operator?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/operator/delete", {
              operator_id: operator_id,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.refreshOperator();
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
    // 0=>pending 1=>active 2=>inactive
    // here status == invitation_claimed
    changeOperatorStatus(operator_id,status){

        if(status==0){
          this.$toasted.show("You can not update pending status!",{
                  icon : 'times-circle',
                  className: 'error-class'
                });  
          return; 
        }
        const statusChangeTo = status === 1 ? 2 : 1;
        const vm = this;
        let message = "Do you want to change the operator/user status?";
        const self = this;
        this.$swal({
          title: "Are you sure?",
          text: message,
          showCancelButton: true,
        }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/operator/status-update", {
              operator_id: operator_id,
              status: statusChangeTo,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                vm.refreshOperator();
              }
              else{
                this.$toasted.show(res.data.message,{
                  icon : 'times-circle',
                  className: 'error-class'
                });   
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    getRoleLists(){
      let owner_id = localStorage.getItem('user_id');

      if (this.role_source) {
        this.role_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.role_source = CancelToken.source();

      this.axios
        .post(window.hostname + "/api/auth/role/list", {
            owner_id:owner_id,
            page: this.globalPagination.page,
            order_by:     this.order_by,
            field_name:   this.field_name,
            search: this.search,
            status: this.selected_status,
          },
          {
            cancelToken: this.role_source.token,
          }     
        ).then((res)=>{
          //this.roleList =res.data.data.role_list;
           if (res.data.status && Object.keys(res.data.data).length > 0 ) {
            //this.departmentLists = res.data.data.department_list;

            let role_lists = res.data.data.role_list;
            role_lists.map((val) => {
              this.roleList.push(val);
            });
          
            this.globalPagination.page = res.data.data.pagination.page;
            this.globalPagination.load_more =
              res.data.data.pagination.load_more == 1 ? true : false;
            this.globalPagination.to = res.data.data.pagination.to;
            this.globalPagination.total = res.data.data.pagination.total;
            this.role_infiniteId++;
          } else {
            this.globalPagination.page = 1;
            this.globalPagination.load_more = false;
            this.globalPagination.total = 0;
            this.globalPagination.to = 0;
            this.roleList = [];
          }
          
        })
        .catch((err) => {
           console.log(err);
        });
    },
    changeRoleStatus(roleId, status) {
      const statusChangeTo = status === 0 ? 1 : 0;
      const vm = this;
      let message = "Do you want to change the role status?";
      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/role/update", {
              id: roleId,
              status: statusChangeTo,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                vm.refreshRole();
              }
              else{
                this.$toasted.show(res.data.message,{
                  icon : 'times-circle',
                  className: 'error-class'
                });   
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    editRole(role){
      this.$modal.show("edit-roles-modal", {
        role: JSON.parse(JSON.stringify(role)),
      });
    },
    deleteRole(role_id){

      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this Role?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/role/delete", {
              id: role_id,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.refreshRole();
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });

    },
    refreshRole(){
      this.globalPagination.page = 1;
      this.globalPagination.load_more = false;
      this.roleList=[],
      this.getRoleLists();
    },
    getDepartmentLists(){

      if (this.department_source) {
        this.department_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.department_source = CancelToken.source();

        this.axios
        .post(
          window.hostname + "/api/auth/departments/list",
          {
            commercial: 1,
            page: this.globalPagination.page,
            order_by:     this.order_by,
            field_name:   this.field_name,
            search: this.search,
            status: this.selected_status,
          },
          {
            cancelToken: this.department_source.token,
          }
        )
        .then((res) => {
          if (res.data.status && Object.keys(res.data.data).length > 0 ) {
            //this.departmentLists = res.data.data.department_list;

            let department_Lists = res.data.data.department_list;
            department_Lists.map((val) => {
              this.departmentLists.push(val);
            });

            console.log(this.departmentLists.length);
            console.log(res.data.data.department_list);
            //alert(res.data.data.pagination.page);
            this.globalPagination.page = res.data.data.pagination.page;
            
            this.globalPagination.load_more =
              res.data.data.pagination.load_more == 1 ? true : false;
            this.globalPagination.to = res.data.data.pagination.to;
            this.globalPagination.total = res.data.data.pagination.total;
            this.department_infiniteId++;
          } else {
            this.globalPagination.page = 1;
            this.globalPagination.load_more = false;
            this.globalPagination.total = 0;
            this.globalPagination.to = 0;
            this.departmentLists = [];
          }
        })
        .catch((err) => {
          // console.log(err);
        });

    },
    editDepartment(department){
      this.$modal.show("edit-department-modal", {
        department: JSON.parse(JSON.stringify(department)),
      });
    },
    deleteDepartment(department_id){

      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this Department?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/departments/delete", {
              id: department_id,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.refreshDepartment();
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });
    },
    refreshDepartment(){
      this.globalPagination.page = 1;
      this.globalPagination.load_more = false;
      this.departmentLists = [];
      this.getDepartmentLists();

    },
    changeDepartmentStatus(deptId, status) {
      const statusChangeTo = status === 0 ? 1 : 0;
      const vm = this;
      let message = "Do you want to change the department status?";
      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: message,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/departments/update", {
              id: deptId,
              status: statusChangeTo,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                vm.refreshDepartment();
              }
              else{
                this.$toasted.show(res.data.message,{
                  icon : 'times-circle',
                  className: 'error-class'
                });   
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },  
   
  },
};
</script>

<style scoped>
/* style the background and the text color of the input ... */
.vue-tags-input {
  border-radius: 16px !important;
  background: transparent !important;
  font-size: 12px !important;
  padding: 0 0.6rem !important;
  border: 1px solid hsla(0, 0%, 100%, 0.25) !important;
  max-width: 100% !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  color: hsla(0, 0%, 100%, 0.5);
}

.vue-tags-input.ti-focus {
  border-color: #f5a621 !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent !important;
  color: #b7c4c9;
}

.ti-input {
  border: 0 !important;
  padding: 4px 10px;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ebde6e;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #191919 !important;
  border: 0 !important;
  border-top: none !important;
  border-radius: 10px !important;
  width: 148px !important;
  top: 35px !important;
  padding-top: 10px !important;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item {
  color: #fff;
}

.vue-tags-input .ti-item.ti-selected-item {
  background-color: transparent;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative !important;
  background: transparent !important;
  color: #fff !important;
  align-items: center !important;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}

.ti-tag .ti-actions {
  background-color: rgba(255, 255, 255, 0.2) !important;
  font-size: 8px !important;
  justify-content: center !important;
  width: 13px !important;
  height: 13px !important;
  border-radius: 100% !important;
  color: rgba(255, 255, 255, 0.25) !important;
}

.date-range-time-class-audit .date__range__input .field.is-dark .field-input {
  width: 150px;
  padding: 0 10px;
}

.date-range-time-class-audit .time-picker::after,
.date-range-time-class-audit .time-picker::before {
  border-top: 0;
  border-bottom: 0;
}

@media (max-width: 460px) {
  .date-range-time-class-audit {
    flex-direction: column;
  }

  .date-range-time-class-audit .separator {
    display: none;
  }

  .date-range-time-class-audit .date__range__input {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>